function fixJudgeMeA11y() {
  // Fix 1: icone next/prev recensioni senza ruolo valido per aria-label
  document.querySelectorAll('.jdgm-rev-snippet-widget__next-btn, .jdgm-rev-snippet-widget__prev-btn')
    .forEach(function(el) {
      if (!el.hasAttribute('role')) {
        el.setAttribute('role', 'button');
      }
    });

  // Fix 2: link "leggi recensione completa" senza testo discernibile
  document.querySelectorAll('.jdgm-rev-snippet-card__full-review-link')
    .forEach(function(el) {
      if (!el.textContent.trim() && !el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', 'Leggi la recensione completa');
      }
    });
}

// Il widget Judge.me si carica in modo asincrono, quindi osserviamo il DOM
var jdgmObserver = new MutationObserver(fixJudgeMeA11y);
jdgmObserver.observe(document.body, { childList: true, subtree: true });

// Esecuzione immediata nel caso il widget sia già presente
fixJudgeMeA11y();